<ui-avatar
  [uiType]="type"
  [uiPicture]="picture"
  [uiSize]="size"
  [uiIcon]="icon"
  [uiTheme]="theme"
  [uiBgColor]="backgroundColor"
  [uiTooltipTitle]="showTooltip && avatarTooltipTemplate"
  [uiTooltipPlacement]="tooltipPlacement"
  [uiDisabled]="disabled"
  [ngClass]="{ 'ui-deleted-avatar': isDeleted }"
  [attr.data-test-id]="'assignee-name ' + assigneeName"
  (error)="onError()"></ui-avatar>

<ng-template #avatarTooltipTemplate>
  <gh-full-name class="ui-avatar-tooltip" [ghFullNameSettings]="{ multiline: true, center: true }" [ghFullNameEntity]="assignee"></gh-full-name>
</ng-template>
